<template>
  <v-slide-y-reverse-transition>
    <div v-if="downloads.length" class="floating-download-wrapper">
      <v-card class="floating-card px-3 pb-3" elevation="8">
        <div
          class="card-header mb-2 text-body-2 font-weight-bold d-flex align-center"
        >
          Fazendo download de {{ downloads.length }} arquivo(s)

          <v-spacer />

          <v-btn small icon @click="closeMenu()">
            <v-icon color="black" small>mdi-window-minimize</v-icon>
          </v-btn>
        </div>

        <div
          v-for="download in downloads"
          :key="download.id"
          class="download-item"
        >
          <div class="download-header flex-nowrap">
            <span>{{ download.label }}</span>

            <span v-if="download.status === 'downloading'">
              {{ download.progressText }}

              <v-icon small color="red" @click="cancelDownload(download.id)">
                mdi-close-thick
              </v-icon>
            </span>

            <v-icon v-else-if="download.status === 'done'" small color="green">
              mdi-checkbox-marked-circle-outline
            </v-icon>

            <v-icon v-else-if="download.status === 'error'" small color="red">
              mdi-alert-circle-outline
            </v-icon>
          </div>

          <v-progress-linear
            v-if="download.status === 'downloading'"
            indeterminate
            height="6"
            rounded
            striped
            color="primary"
          />

          <v-progress-linear
            v-else
            value="100"
            height="6"
            rounded
            striped
            :color="download.status === 'done' ? 'green' : 'red'"
          />
        </div>
      </v-card>
    </div>
  </v-slide-y-reverse-transition>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "FloatingDownload",

  computed: {
    ...mapState({
      downloads: (state) => state.download.queue,
    }),
  },

  methods: {
    ...mapActions("download", ["clearDownloads", "cancelDownload"]),

    closeMenu() {
      this.clearDownloads();
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
